import { render, staticRenderFns } from "./AddNewProductFromUrl.vue?vue&type=template&id=50b985e4&"
import script from "./AddNewProductFromUrl.vue?vue&type=script&lang=js&"
export * from "./AddNewProductFromUrl.vue?vue&type=script&lang=js&"
import style0 from "./AddNewProductFromUrl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports